import { TourStep } from "./tourTypes";

export const tourSteps: TourStep[] = [
  {
    id: 1,
    title: "👤 Tap your Profile",
    description: "Access your settings and manage your Profile",
    targetSelector: "#profile",
    position: "right",
    route: "/dashboard",
  },
  {
    id: 2,
    title: "✅ Ready for Projects?",
    description: (
      <>
        Toggle this ON to show you're available. Your profile will appear in
        actor suggestions{" "}
        <span className="font-semibold text-[#000000]">
          only when this is enabled
        </span>
        , and you'll also start seeing relevant project listings.
      </>
    ),
    targetSelector: "#projects-active-status",
    position: "right",
    route: "/profile",
  },
  {
    id: 3,
    title: "🎯 Boost Your Visibility",
    description: (
      <>
        Add as many wardrobe styles and background images as you can —{" "}
        <span className="font-semibold text-[#000000]">
          the more you share, the better your chances
        </span>{" "}
        of getting selected. And don’t forget to keep your profile fresh and up
        to date!
      </>
    ),
    targetSelector: "#wardrobe-background",
    position: "right",
    route: "/profile",
  },
  {
    id: 4,
    title: "📂 View Your Opportunities",
    description: (
      <>
        Tap on{" "}
        <span className="font-semibold text-[#000000]">"Jobs for You" </span> to
        see all the projects you’ve been matched with or invited to — your next
        gig could be waiting there!
      </>
    ),
    targetSelector: "#jobs",
    position: "right",
    route: "/jobs",
  },
  {
    id: 5,
    title: "💰 Your Wallet, Simplified",
    description: (
      <>
        Click here to view your wallet — track your earnings, monitor payments,
        and
        <span className="font-semibold text-[#000000]">
          {" "}
          withdraw your money
        </span>{" "}
        anytime with ease.
      </>
    ),
    targetSelector: "#wallet",
    position: "right",
    route: "/wallet",
  },
  {
    id: 6,
    title: "🏦 Add Your Bank Details",
    description: (
      <>
        Link your bank account here to receive payments securely and without
        delays. It’s quick, safe, and{" "}
        <span className="font-semibold text-[#000000]">
          {" "}
          essential to get paid.
        </span>
      </>
    ),
    targetSelector: "#btn-add-bank-account",
    position: "bottom",
    route: "/wallet",
  },
  {
    id: 7,
    title: "🔔 Stay in the Loop",
    description: (
      <>
        All your important updates, project alerts, and platform notifications
        will appear here. Keep an eye out—{" "}
        <span className="font-semibold text-[#000000]">
          this is key to managing your work smoothly.
        </span>
      </>
    ),
    targetSelector: "#notification",
    position: "right",
    route: "/dashboard",
  },
  {
    id: 8,
    title: "Congratulations!",
    description:
      "You've completed the tour! You're now ready to make the most of our application.",
    targetSelector: "#app-container",
    position: "center",
    route: "/dashboard",
  },
];
